import styled from 'styled-components';

const BtnFavorite = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background-color: transparent;
`;

export default BtnFavorite;
